import { __extends } from '../../../../node_modules/tslib/tslib.es6.js';
import { utils, Contract, ContractFactory } from 'ethers';

var _abi = [{
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }, {
    internalType: "address",
    name: "_rewardsDistribution",
    type: "address"
  }, {
    internalType: "address[]",
    name: "_rewardTokens",
    type: "address[]"
  }, {
    internalType: "address",
    name: "_stakingToken",
    type: "address"
  }, {
    internalType: "address",
    name: "_registry",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint256",
    name: "newStart",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "newDuration",
    type: "uint256"
  }],
  name: "FreeTokensClaimed",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "oldOwner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnerChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnerNominated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "bool",
    name: "isPaused",
    type: "bool"
  }],
  name: "PauseChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint256",
    name: "reward",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "token",
    type: "address"
  }],
  name: "RewardAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint256",
    name: "newStart",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "newDuration",
    type: "uint256"
  }],
  name: "RewardDurationUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "reward",
    type: "uint256"
  }],
  name: "RewardPaid",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "Staked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "Withdrawn",
  type: "event"
}, {
  inputs: [],
  name: "acceptOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "claimFreeTokens",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_account",
    type: "address"
  }, {
    internalType: "address",
    name: "_token",
    type: "address"
  }],
  name: "earned",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "exit",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "freeTokens",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_token",
    type: "address"
  }],
  name: "getFreeTokenAmount",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "getReward",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_token",
    type: "address"
  }],
  name: "getRewardForDuration",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "_periodStart",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_rewardsDuration",
    type: "uint256"
  }, {
    internalType: "uint256[]",
    name: "_rewards",
    type: "uint256[]"
  }, {
    internalType: "address[]",
    name: "_tokens",
    type: "address[]"
  }],
  name: "initCampaign",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_token",
    type: "address"
  }],
  name: "isValidRewardToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "lastPauseTime",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "lastTimeRewardApplicable",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "lastUnstake",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "lastUpdateTime",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "nominateNewOwner",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominatedOwner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "periodFinish",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "periodStart",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "contract IStakingRegistry",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_token",
    type: "address"
  }],
  name: "rewardPerToken",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "rewardTokens",
  outputs: [{
    internalType: "uint256",
    name: "rewardRate",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "rewardPerTokenStored",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "rewardTokensAddresses",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "rewards",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "rewardsDistribution",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "rewardsDuration",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bool",
    name: "_paused",
    type: "bool"
  }],
  name: "setPaused",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_rewardsDistribution",
    type: "address"
  }],
  name: "setRewardsDistribution",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "stake",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "token",
  outputs: [{
    internalType: "contract IERC20",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "tokenDecimals",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "totalSupply",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "userRewardPerTokenPaid",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "withdraw",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
var _bytecode = "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";
var isSuperArgs = function (xs) {
  return xs.length > 1;
};
var RollStakingRewards__factory = /** @class */function (_super) {
  __extends(RollStakingRewards__factory, _super);
  function RollStakingRewards__factory() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = this;
    if (isSuperArgs(args)) {
      _this = _super.apply(this, args) || this;
    } else {
      _this = _super.call(this, _abi, _bytecode, args[0]) || this;
    }
    return _this;
  }
  RollStakingRewards__factory.prototype.deploy = function (_owner, _rewardsDistribution, _rewardTokens, _stakingToken, _registry, overrides) {
    return _super.prototype.deploy.call(this, _owner, _rewardsDistribution, _rewardTokens, _stakingToken, _registry, overrides || {});
  };
  RollStakingRewards__factory.prototype.getDeployTransaction = function (_owner, _rewardsDistribution, _rewardTokens, _stakingToken, _registry, overrides) {
    return _super.prototype.getDeployTransaction.call(this, _owner, _rewardsDistribution, _rewardTokens, _stakingToken, _registry, overrides || {});
  };
  RollStakingRewards__factory.prototype.attach = function (address) {
    return _super.prototype.attach.call(this, address);
  };
  RollStakingRewards__factory.prototype.connect = function (signer) {
    return _super.prototype.connect.call(this, signer);
  };
  RollStakingRewards__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  RollStakingRewards__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  RollStakingRewards__factory.bytecode = _bytecode;
  RollStakingRewards__factory.abi = _abi;
  return RollStakingRewards__factory;
}(ContractFactory);

export { RollStakingRewards__factory };
